<template>
    <section class="container container--calcPadding margin-both-xl">
        <div class="content" ref="content" v-once>
        </div>
    </section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'form-picker',
    props : ['data'],
    mounted(){
        const content = this.$refs.content;
        const formId = this.data.form_id;
        if(formId){
            this.loadGravityForm2(formId, content)
        }
    },
    methods:{
        ...mapActions([
           // 'loadGravityForm'
        ]),
        loadGravityForm2(formId, content){
            const apiUrl  = window.WPVUE.home.replace('/system', '')+'/'+window.WPVUE.ajaxurl
			return window.axios.get(apiUrl, {
                params: {
                    action : 'gf_button_get_form',
                    form_id : formId
                }}).then(res => {

                    if ( typeof window['gformInitDatepicker'] !== 'undefined' ) {
                        window.gformInitDatepicker()
                    }
                    if(content) {
                        window.jQuery(content).html(res.data)
                    }
                    return res;
                })
        },
    }
}
</script>

